import { createFileRoute } from "@tanstack/react-router"
import { SearchValue } from "../../-components/infinit-scrolling-table/extended-infinit-scrolling-table.tsx"
import { ProductionsPage } from "./-components/ProductionsPage.tsx"

export interface Search extends SearchValue<"/api/Production/GetTable"> {
  view: "table" | "list"
  searchString: string
  reminderDetailOpened?: boolean
  reminderId?: number
}

export const Route = createFileRoute("/app/art/productions/")({
  component: ProductionsPage,
  validateSearch: (search: Search) => ({
    ...search,
    reminderDetailOpened: search.reminderDetailOpened,
    reminderId: search.reminderId,
  }),
})
